<template>
  <div id="today_page">
    <div class="container">
      <div class="base-alert base-alert-error" v-if="!userClaims.email_verified || !userClaims.phone_verified || !userClaims.photo_uploaded">
        <!-- If email or phone are not verified -->
        <span v-if="!userClaims.email_verified || !userClaims.phone_verified">Your profile isn't verified, <router-link to="/profile-verification?verifications=EMAIL,PHONE,PHOTO&direct=true">click here</router-link> to complete it.</span>
        <!-- If only photo no uploaded -->
        <span v-else>You don't have a profile photo, <router-link to="/profile-verification?verifications=PHOTO&direct=true">click here</router-link> to upload one.</span>
      </div>

      <!-- Weather icon and summary -->
      <div class="weather-info">
        <div>
          <div class="weather-left">
            <img :src="weather_icon" alt="">
          </div>
        </div>
        <div>
          <div class="weather-right">
            <span class="today-temperature">{{ Math.round(this.weather_data.currently.temperature || 0) }}°C</span>
            <span class="today-summary">{{ weather_data.hourly.summary || 'Loading...' }}</span>
          </div>
        </div>
      </div>

      <hr style="margin-bottom: 15px" />

      <!-- Weather stats and hourly breakdown -->
      <div class="weather-stats">
        <div id="today_weather_other_container">
          <div>
            <span>Humidity</span>
            <span>{{ Math.round(weather_data.currently.humidity * 100) || 0 }}%</span>
          </div>

          <div>
            <span>Rain</span>
            <span>{{ Math.round(weather_data.currently.precipProbability * 100) || 0 }}%</span>
          </div>

          <div>
            <span>Wind</span>
            <span>{{ Math.round(weather_data.currently.windSpeed) || 0 }}<span style="font-size: 12px">km/h</span></span>
          </div>

          <div class="scroll_arrow">
            <font-awesome-icon
                style="font-size: 14px"
                :icon="['fas', 'chevron-right']"
              />
          </div>
        </div>

        <!-- Hourly weather -->
        <div id="today_weather_other_daily">
          <div :key="item.time" v-for="item in weather_data.hourly.data.slice(0, 12)">
            <div class="today_weather_daily_image">
              <img :src="getWeatherIcon(item.icon)" alt="">
            </div>
            <span>{{ getFormattedTime(item.time) }}</span>
          </div>
          
        </div>
      </div>

      <hr style="margin-top: 10px;" />

      <span class="small-title">Your trip {{ direction == 'go' ? 'to work' : 'home'}}</span>

      <div class="today-schedule">
        <div v-if="schedule && schedule.type.split('.')[0] == 'carpooling'" class="today-schedule-carpooling">
          <el-card style="margin-bottom: 10px" :body-style="{'padding': '15px'}" v-for="carpooler in schedule.options" :key="carpooler.user">
            <div class="today-schedule-carpooling-info user-card-body">
              <div style="height: 56px">
                <el-avatar @click.native="$router.push(`/carpooling-profile/${carpooler.user}`)" :size="56" :src="getUserPhoto(carpooler.user, '128')"></el-avatar>
              </div>
              <div class="user-card-info">
                <span>{{ carpooler.display_name }}</span>
                <span>{{ schedule.type == 'carpooling.driver' ? 'Passenger' : 'Driver' }} &nbsp;&#8226;&nbsp;</span>
              </div>
            </div>

            <div class="today-schedule-chat">
              <el-input v-model="to_send_message" placeholder="Type a message"></el-input>
              <el-button @click="sendWhatsapp(carpooler.phone_number)" type="success" icon="el-icon-s-promotion" circle></el-button>
            </div>
          </el-card>
        </div>

        <div v-if="!schedule" class="today-schedule-empty">
          <el-card v-if="userData.carpooling_details && userData.carpooling_details.available">
            <div style="text-align: center">
              <img :src="publicPath + 'img/idea-globe.svg'" style="max-width: 120px">
            </div>
            <span style="display: block; text-align: center; margin-top: 7px">You have nothing scheduled today. <router-link class="highlighted" to="/search">Click here</router-link> to find carpooling partners.</span>
          </el-card>

          <el-card v-else>
            <div style="text-align: center">
              <img :src="publicPath + 'img/idea-friends.svg'" style="max-width: 120px">
            </div>

            <span style="display: block; text-align: center; margin-top: 7px">Your profile is set to <i>not available</i>.</span>
            <span style="display: block; text-align: center; margin-top: 7px">To allow people to send you requests, set yourself as available <router-link class="highlighted" to="/settings/carpooling-info">here</router-link>.</span>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import localforage from 'localforage';
import moment from 'moment';

let weather_icon_images = {
  "clear-day": "Sun.png",
  "clear-night": "Moon.png",
  rain: "Rainy.png",
  snow: "Snow.png",
  sleet: "Rainy.png",
  wind: "Cloud-wind.png",
  fog: "Closet.png",
  cloudy: "Closet.png",
  "partly-cloudy-day": "Sunshine.png",
  "partly-cloudy-night": "Night.png",
  hail: "Snow.png",
  thunderstorm: "Rainy-thunder.png",
  tornado: "tonado.png"
};

export default {
    data() {
      return {
        weather_data: {
          currently: {},
          hourly: {
            data: []
          }
        },
        to_send_message: '',
        weather_label: '',
        publicPath: process.env.BASE_URL
      }
    },

    async mounted() {
      // this.getRealtimeBuses();
      this.setWeatherData(await localforage.getItem('weatherData'));

      // Refresh token to get new claims
      this.$store.dispatch('checkUserClaims', true);

      // Request weather data
      let _data = await this.SharoAPI({ action: 'corsAnywhere', data: `https://api.darksky.net/forecast/aab12243b64c15175ecab309aa195fae/${53.3498},${-6.2603}?units=si&exclude=minutely,daily,alerts,flags` });

      localforage.setItem('weatherData', _data.data.result);
      this.setWeatherData(_data.data.result);

    },

    methods: {
      setWeatherData(data) {
        this.weather_data = !data ? { hourly: { data: [] }, currently: {}} : data;
        this.weather_label = weather_icon_images[this.weather_data.currently.icon];
      },

      getWeatherIcon(icon) {
        return `${process.env.BASE_URL}img/weather-icons/${weather_icon_images[icon]}`
      },

      getFormattedTime(time) {
        return moment(time * 1000).format('HH:mm');
      },

      getRealtimeBuses() {
        fetch('https://cors-anywhere.herokuapp.com/https://data.dublinked.ie/cgi-bin/rtpi/realtimebusinformation?stopid=184',
          {
            headers: {
              "Content-Type": "application/json"
            }
          }).then(async response => {
            // console.log(response)
          let result = await response.json();
          console.log(result);
        });
      },
      
      datetime(time) {
        return moment(time).format('HH:mm');
      },

      sendWhatsapp(phone_number) {
        let message = this.to_send_message;
        this.to_send_message = '';

        if (['iPhone', 'iPad', 'iPod'].includes(navigator.platform)) {
          const win = window.open(`https://wa.me/${phone_number}?text=${encodeURI(message)}`, '_top');
          return win.focus();
        }

        window.open(`https://wa.me/${phone_number}?text=${encodeURI(message)}`);
      }
    },

    computed: {
      userData() {
        return this.$store.getters.user.data;  
      },
      
      weather_icon() {
        return `${process.env.BASE_URL}img/weather-icons/${this.weather_label}`;
      },

      direction() {
        return moment().hour() < 12 ? 'go' : 'back';
      },

      schedule() {
        return this.$store.getters.userSchedule && this.$store.getters.userSchedule[moment().format('YYYY-MM-DD')] && this.$store.getters.userSchedule[moment().format('YYYY-MM-DD')][this.direction];
      },

      userClaims() {
        return this.$store.getters.userClaims || {};
      },

      ip() {
        return this.$store.getters.ip_information;
      }
    }

}
</script>

<style lang="scss" scoped>
  @import "today.scss";

  .container {
    max-width: 600px;
  }

  .full-tabs {
    margin-top: 15px;
  }
</style>